import { render, staticRenderFns } from "./QuestionnaireViewSection.vue?vue&type=template&id=8b2a9a32&"
import script from "./QuestionnaireViewSection.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireViewSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports